
export default class Config {

    encrypt( str ) {
        let result = '';
        for ( let i = 0; i < str.length; i++ ) {
            const charCode = str.charCodeAt(i);
            result += String.fromCharCode( charCode + 1 );
        }
        return result;
    }

    decrypt( str ) {
        let result = '';
        for ( let i = 0; i < str.length; i++ ) {
            const charCode = str.charCodeAt(i);
            result += String.fromCharCode( charCode - 1 );
        }
        return result;
    }

    save() {
        localStorage.setItem( 'isslog-config', JSON.stringify( window.config ));
    }

    constructor() {
        this.title = window.config.title;
        this.user  = window.config.user;
        this.repo  = window.config.repo;
        this.token = this.decrypt( window.config.token );
        this.auth  = window.config.auth;
        this.pagesize = window.config.pagesize;
        this.order = window.config.order;
        this.memos = window.config.memos;
        this.inbox = window.config.inbox;
        this.save();
    }
}